import React, { useState } from 'react';
import
  PropTypes
from 'prop-types';
import { MainContainer, ParagraphWhite, SnackContainer, SnackContent } from './Snackbar.styles';
import close from '../../../images/close-white.svg'
export const Snackbar = (props) => {

  const [ display, setDisplay ] = useState('none');

  return (
    <MainContainer display={props.display ? props.display : display}>
      <SnackContainer>
        <SnackContent>
          <ParagraphWhite>{props.otpResendMessages.line1}</ParagraphWhite>
          <ParagraphWhite>{props.otpResendMessages.line2}</ParagraphWhite>
        </SnackContent>
        <div>
          <span style={{cursor: 'pointer'}} onClick={() => props.setDisplay('none')}>
            <img src={close} alt='close'/>
          </span>
        </div>
      </SnackContainer>
    </MainContainer>
)
};

Snackbar.propTypes = {
  otpResendMessages: PropTypes.object,
  display: PropTypes.string,
  setDisplay: PropTypes.func
};

Snackbar.defaultProps = {
  otpResendMessages: {},
  display: '',
  setDisplay: ()=>{}
};
